import { Stack } from '@mui/material';
import { UserStatus as UserStatusType } from 'src/@types/user-status';
import Iconify from 'src/components/iconify';
import UserStatus from 'src/components/status';
import { useLocales } from 'src/locales';
import { STATUS } from '../../../layouts/shared/Header/AccountPopover/constants';

type Props = {
  selectedStatus: UserStatusType;
  handleStatusChange: (status: UserStatusType) => void;
};

export const UserStatusOptions = ({
  selectedStatus,
  handleStatusChange,
}: Props) => {
  const { translate } = useLocales();

  return (
    <Stack spacing={0.5}>
      {STATUS.map((status, index: number) => (
        <UserStatus
          key={`accountpopover-status-${index}`}
          icon={<Iconify icon={status.icon} color={status.color} />}
          label={`${translate(`header.profile_dropdown.status.${status.label}`)}`}
          changeStatus={handleStatusChange}
          selectedStatus={selectedStatus}
          value={status.value}
        />
      ))}
    </Stack>
  );
};
